import React from 'react'
import UserList from '../components-dev-admin/UserList'

export default function PlatformUsers() {
  return (
    <UserList />
  )
}
